import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import T from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { blackAlpha16, white } from '../../styles/colors';
import { unit } from '../../styles/unit';
import { layout } from '../../styles/system';
import { MenuItem } from './MenuItem';
import { MenuSeparator } from './MenuSeparator';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = /*#__PURE__*/styled.ul.withConfig({
  displayName: "Container",
  componentId: "sc-1cqevmx-0"
})(["display:block;min-width:200px;box-sizing:border-box;padding:", " 0;background-color:", ";border:1px solid ", ";box-shadow:0px 4px 8px ", ";border-radius:4px;margin:0;overflow-x:auto;-webkit-overflow-scrolling:touch;", " &[hidden]{display:none;}"], unit(2), white, blackAlpha16, blackAlpha16, layout);
const Menu = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    role = 'menu'
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "role"]);

  return /*#__PURE__*/_jsx(Container, Object.assign({}, restProps, {
    ref: forwardedRef,
    role: role,
    children: children
  }));
});
Menu.propTypes = {
  children: T.node.isRequired,
  role: T.string
};
export { Menu, MenuItem, MenuSeparator };